/* RustGo home interactions: tabs, reviews carousel, mobile menu, announcement rotation. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tabs() {
    document.querySelectorAll('[data-sc-tabs]').forEach(function (wrap) {
      var list = wrap.querySelectorAll('[role="tab"]');
      function pick(t) {
        list.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
        if (window.RGInitVideos) window.RGInitVideos(wrap);
      }
      list.forEach(function (t, i) {
        t.addEventListener('click', function () { pick(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? list[(i + 1) % list.length] : e.key === 'ArrowLeft' ? list[(i - 1 + list.length) % list.length] : null;
          if (n) { e.preventDefault(); n.focus(); pick(n); }
        });
      });
    });
  }

  function carousel() {
    document.querySelectorAll('[data-sc-carousel]').forEach(function (c) {
      var track = c.querySelector('.sc-carousel__track');
      var dots = c.querySelectorAll('.sc-dots button');
      var cards = track.children;
      function step() { return cards[0] ? cards[0].getBoundingClientRect().width + 30 : track.clientWidth; }
      c.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: step() * Number(b.dataset.dir), behavior: reduce ? 'auto' : 'smooth' }); });
      });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { track.scrollTo({ left: step() * i, behavior: reduce ? 'auto' : 'smooth' }); }); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { var i = Math.round(track.scrollLeft / step()); dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i); }); }, 80);
      }, { passive: true });
    });
  }

  function menu() {
    var b = document.querySelector('[data-sc-burger]'); var d = document.getElementById('sc-drawer');
    if (!b || !d) return;
    b.addEventListener('click', function () { var open = d.classList.toggle('is-open'); b.setAttribute('aria-expanded', open); });
  }

  function rotate() {
    var box = document.querySelector('[data-sc-rotate]'); if (!box || reduce) return;
    var slides = box.querySelectorAll('.sc-announce__slide:not(.sc-announce__slide--desk)'); var i = 0;
    if (slides.length < 2) return;
    setInterval(function () { slides[i].classList.remove('is-on'); i = (i + 1) % slides.length; slides[i].classList.add('is-on'); }, 4000);
  }

  ready(function () { tabs(); carousel(); menu(); rotate(); });
})();
